<div
   #notesModal
   class="modal fade modal-padding">
   <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
         <div class="modal-header header-border align-items-center justify-content-between p-0">
            <h5 class="modal-title">Issue Helpdesk Ticket</h5>
            <button
               type="button"
               class="btn-close position-static"
               aria-label="Close"
               (click)="bootstrapModal.hide()">
               <span aria-hidden="true">×</span>
            </button>
         </div>
         <div class="modal-body p-0">
            <div class="notes-editor">
               <div class="note-edit-wrap">
                  <textarea
                     [(ngModel)]="zohoFeedback"
                     class="form-control form-control-sm feedbackEditor"
                     rows="3"
                     placeholder="Please describe your concern"></textarea>
                  <div class="text-end note-btns">
                     <a
                        href="javascript:void(0);"
                        class="v-button v-button-md v-green"
                        (click)="createTicket()">
                        Create Ticket
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
